// extracted by mini-css-extract-plugin
module.exports = {"Confirmation":"Confirmation_Confirmation__2b_8n","title":"Confirmation_title__2O_zW","content":"Confirmation_content__1ALX-","toHome":"Confirmation_toHome__Webwk"};